export const LOTTERY_COUNT_TABS = [
  { title: 'แสดง(ในเว็บ)', value: 'PUBLISH' },
  { title: 'ไม่แสดง(ในTemp)', value: 'HIDE' },
  { title: 'ซื้อแล้ว', value: 'BOUGHT' },
]
